import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Les routes admin sont maintenant définies directement dans app-routing.module.ts
const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
